import { Flex } from "@engaging-tech/components"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import { mergeSponsors } from "../../../helpers/sponsors"
import getWhwSponsors from "../../../services/sponsors"
import { getActiveFilters } from "../store/rankings.selectors"
import WHWSponsorsCarousel from "./WHWSponsors"

const SideCards = () => {
  const activeFilters = useSelector(getActiveFilters)
  const [allSponsors, setAllSponsors] = useState()
  const activeCountryFilter = activeFilters?.activeCountry?.id || null

  useEffect(() => {
    async function loadSponsors() {
      const res = await getWhwSponsors()
      setAllSponsors(res)
    }
    loadSponsors()
  }, [setAllSponsors])

  const allPartnersLabel = activeCountryFilter ? `${activeCountryFilter} Partners` : "All Partners"

  const mergedSponsors = allSponsors?.data?.sponsors ? mergeSponsors(allSponsors?.data?.sponsors) : []

  return (
    <Flex flexDirection="column" width={[1 / 1, 1 / 1, "240px"]}>
      <WHWSponsorsCarousel
        isLoading={allSponsors?.isLoading}
        slides={allSponsors?.data?.sponsors?.globalPartners?.data || []}
      />
      <WHWSponsorsCarousel
        isLoading={allSponsors?.isLoading}
        label={allPartnersLabel}
        slides={mergedSponsors}
      />
    </Flex>
  )
}

export default SideCards
